import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, Spinner } from "reactstrap";
import { postJson } from "../hook/request";

type TipoSuggerimento = "Bug" | "Possibili miglioramenti";

export default function Bug() {


  const [isOpen, setIsOpen] = useState(false);
  const [tipo, setTipo] = useState<TipoSuggerimento>("Bug");
  const [testo, setTesto] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);

  const openModal = () => {
    setIsOpen(true);
    setError(null);
    setSent(false);
  };

  const closeModal = () => {
    if (!isSending) setIsOpen(false);
  };

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSent(false);

    const testoTrim = testo.trim();
    if (!testoTrim) {
      setError("Inserisci un testo prima di inviare.");
      return;
    }

    setIsSending(true);
    try {
      await postJson("/data/suggerimenti", {
        tipo,       
        testo: testoTrim,
        pagina: window.location.href,
      });

      setSent(true);
      setTesto("");
      setTipo("Bug");
    } catch (err: any) {
      setError("Invio non riuscito. Riprova.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <>
        <div
        onClick={openModal}
        className="tap-top"
        style={{display:'block', left: 30, cursor: 'pointer', backgroundColor:'red' }}
        role="button"
        aria-label="Apri suggerimenti"
        tabIndex={0}
        onKeyDown={(e) => (e.key === "Enter" ? openModal() : null)}
        >
            <i className="fa-solid fa-bug"></i>
        </div>


      <Modal isOpen={isOpen} toggle={closeModal} centered>
        <ModalHeader toggle={closeModal}>Invia un suggerimento</ModalHeader>

        <Form onSubmit={onSubmit} className="w-100">
          <ModalBody>
            <FormGroup className="w-100">
              <Label for="tipoSuggerimento">Tipo</Label>
              <Input
                id="tipoSuggerimento"
                type="select"
                value={tipo}
                onChange={(e) => setTipo(e.target.value as TipoSuggerimento)}
                disabled={isSending}
              >
                <option>Bug</option>
                <option>Possibili miglioramenti</option>
              </Input>
            </FormGroup>

            <FormGroup className="w-100">
              <Label for="testoSuggerimento">Testo</Label>
              <Input
                id="testoSuggerimento"
                type="textarea"
                rows={5}
                value={testo}
                onChange={(e) => setTesto(e.target.value)}
                placeholder="Descrivi il problema o il miglioramento..."
                disabled={isSending}
              />
            </FormGroup>

            {error && <div className="text-danger">{error}</div>}
            {sent && <div className="text-success">Inviato! Grazie 🙌</div>}
          </ModalBody>

          <ModalFooter>
            <Button type="button" color="secondary" onClick={closeModal} disabled={isSending}>
              Chiudi
            </Button>
            <Button type="submit" color="primary" disabled={isSending}>
              {isSending ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Invio...
                </>
              ) : (
                "Invia"
              )}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </>
  );
}
